import {fetchIntercomUserHash} from './api';

export const bootIntercom = async user => {
  const app_id = window.intercomSettings.app_id;

  if (!user) {
    return window.Intercom('boot', {app_id});
  }

  const {hash} = await fetchIntercomUserHash();

  window.Intercom('boot', {
    app_id,
    user_id: user.id,
    user_hash: hash,
  });
};
